function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fff"
}, React.createElement("circle", {
  cx: 552,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 543.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 131.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 112.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 109,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 106.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 91.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 83.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 77.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 72.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 70.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 67.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 66,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 63.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 61.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 61.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 55.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 52,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 51.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 50,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 49.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 49.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 48.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 46.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 46.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 46.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 46.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 46.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 44.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 44.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 43.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 43.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 42.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 42.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 42.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 42,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 41.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 41.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 41.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 40.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 40.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 40.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 40.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 39.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 39.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 39.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 38.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 38.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 37.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 37.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 37.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 37,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 36,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 35.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 35.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 35.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 34,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 33.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 32,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 31,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.9,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.8,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.7,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.6,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.5,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.4,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.3,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.2,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30.1,
  cy: 62,
  r: 30,
  opacity: 0.03
}), React.createElement("circle", {
  cx: 30,
  cy: 62,
  r: 30,
  opacity: 0.03
}));

var SvgCountryFigures01 = function SvgCountryFigures01(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 582 124",
    style: {
      backgroundColor: "#0d5b61"
    }
  }, props), _ref);
};

export default SvgCountryFigures01;